var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"view-content d-block d-md-flex align-center justify-center mx-auto"},[_c('e-circular-loading',{attrs:{"value":"","fullPage":false,"size":42}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }